import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './NavBar.scss';
import logo from '../assets/logo.png';
import MobileSidebar from './MobileSidebar';

const NavBar = () => {
    const location = useLocation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const handleClick = (e, path) => {
        if (location.pathname === path) {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    // Prevent body scroll when sidebar is open
    useEffect(() => {
        if (isSidebarOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }

        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isSidebarOpen]);

    return (
        <>
            <nav>
                <div className="nav-container">
                    <Link to="/" className="logo" onClick={(e) => handleClick(e, '/')}>
                        <img src={logo} alt="CHAIropractic" />
                    </Link>
                    <ul className="nav-links">
                        <li><Link to="/" onClick={(e) => handleClick(e, '/')}>Home</Link></li>
                        <li><Link to="/services" onClick={(e) => handleClick(e, '/services')}>Services</Link></li>
                        <li><Link to="/about" onClick={(e) => handleClick(e, '/about')}>About</Link></li>
                        <li><Link to="/conditions" onClick={(e) => handleClick(e, '/conditions')}>Conditions</Link></li>
                        <li><Link to="/contact" onClick={(e) => handleClick(e, '/contact')}>Contact</Link></li>
                    </ul>
                    <button 
                        className="hamburger" 
                        onClick={toggleSidebar}
                        aria-label="Toggle menu"
                    >
                        <span className={isSidebarOpen ? 'open' : ''}></span>
                        <span className={isSidebarOpen ? 'open' : ''}></span>
                        <span className={isSidebarOpen ? 'open' : ''}></span>
                    </button>
                </div>
            </nav>
            <MobileSidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
        </>
    );
};

export default NavBar;

